import { Button } from "@shared/components";
import {
  BUTTON_COLOR,
  BUTTON_SIZE,
  BUTTON_VARIANT,
} from "@shared/components/button/types";
import AngleDownLight from "@svg/angle-down-light";
import classNames from "classnames";
import parse from "html-react-parser";
import { FC, useMemo } from "react";
import { IHowToLearnDetailInput } from "../types";
import { useDetailHeader } from "../hooks/useDetailHeader";
import { options } from "../helpers/detailOption";

interface Props {
  productCollection: IHowToLearnDetailInput;
}

const HowToLearnDetailContent: FC<Props> = ({ productCollection }) => {
  const { visibleShowMore, textRef, isLongText, toggleShowText, showText } =
    useDetailHeader();
  const rawContent = productCollection?.data?.content;

  const parsedContent = useMemo(() => {
    if (!rawContent) return null;
    return parse(rawContent, options);
  }, [rawContent]);

  if (!rawContent) return null;

  return (
    <div
      className={classNames(
        "relative   mt-4     flex justify-center items-center flex-col",
        visibleShowMore ? "pb-2 mb-8 md:mb-12 " : "mb-4"
      )}
    >
      <div
        className={classNames(
          "md:body-lg body-md",
          visibleShowMore &&
            "h-16  relative overflow-hidden before:content-[''] before:left-0 before:right-0 before:bottom-0 before:absolute before:h-16 before:bg-gradient-to-t from-white before:pointer-events-none"
        )}
      >
        <div key={rawContent} ref={textRef}>
          {parsedContent}
        </div>
      </div>
      {!showText && isLongText && (
        <Button
          size={BUTTON_SIZE.LARGE}
          variant={BUTTON_VARIANT.TEXT}
          color={BUTTON_COLOR.PRIMARY}
          endIcon={<AngleDownLight className="text-fds-brand h-5    w-5" />}
          onClick={() => toggleShowText()}
          className="absolute md:-bottom-7 -bottom-4  right-0 "
        >
          بیشتر
        </Button>
      )}
    </div>
  );
};

export default HowToLearnDetailContent;
